import React from "react";
import Footer from "../../Footer";
import Header from "../../Header";
import MenuBar from "../../MenuBar";
import { Button, Typography } from "@mui/material";
import { IoArrowBackOutline, IoChevronForwardSharp } from "react-icons/io5";
import { useNavigate } from "react-router";
import { TbCircleFilled } from "react-icons/tb";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { createContext } from "react";
import { useState } from "react";
import UploadBatchModal from "../../modals/uploadBatchModal";
import BatchRefundModal from "../../modals/batchRefundModal";
// import UploadBatchModal from "../../modals/uploadBatchModal";
// import BatchRefundModal from "../../modals/batchRefundModal";

const refundData = [
  {
    date: "30 June 2023",
    noOfItems: 150,
    totalAmount: 1500,
    refundAmount: 150,
    status: "In progress",
    action: "Approve",
  },
  {
    date: "10 June 2023",
    noOfItems: 150,
    totalAmount: 1500,
    refundAmount: 150,
    status: "Settled",
    action: "Approved",
  },
  {
    date: "15 June 2023",
    noOfItems: 150,
    totalAmount: 1500,
    refundAmount: 150,
    status: "Settled",
    action: "Approved",
  },
  {
    date: "19 June 2023",
    noOfItems: 150,
    totalAmount: 1500,
    refundAmount: 150,
    status: "In progress",
    action: "Approve",
  },
  {
    date: "05 June 2023",
    noOfItems: 150,
    totalAmount: 1500,
    refundAmount: 150,
    status: "In progress",
    action: "Approve",
  },
];

export const MyContext = createContext("");

export default function BatchRefund() {
  const navigate = useNavigate();

  const handleClickForwardIcon = () => {
    navigate("/transactions/batchRefund/batchRefundDeatils");
  };

  const [uploadBatchModal, setUploadBatchModal] = useState(false);

  const handleUploadBatchModal = () => {
    setUploadBatchModal(true);
  };
  const handleCloseUploadBatchModal = () => {
    setUploadBatchModal(false);
  };

  const [batchRefundActionModal, setBatchRefundActionModal] = useState(false);
  const handleSubmitActionButton = () => {
    setBatchRefundActionModal(true);
  };

  const handleCloseBatchRefundActionModal = () => {
    setBatchRefundActionModal(false);
  };

  return (
    <>
      <div
        className="content-wrapper whole-page-body"
        style={{ backgroundColor: "white", padding: "10px 20px 10px 20px" }}
      >
        <section className="content-header" style={{ paddingLeft: "0px" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <p className="main-order-header d-flex">
                  <IoArrowBackOutline
                    style={{ height: "32px", width: "32px", cursor: "pointer" }}
                    onClick={() => navigate("/transactions")}
                  />
                  <Typography
                    variant="h4"
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 700,
                      fontSize: "28px",
                      height: "36px",
                      width: "200px",
                    }}
                  >
                    Batch Refund
                  </Typography>
                </p>
              </div>
              <div className="row align-items-center pl-3 pt-2">
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "rgba(1, 1, 2, 0.92)",
                    height: "18px",
                    width: "143px",
                    fontFamily: "Poppins",
                  }}
                >
                  Order Management
                </Typography>
                <Typography
                  className="pl-2"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "rgba(1, 1, 2, 0.72)",
                    height: "18px",
                  }}
                >
                  <IoChevronForwardSharp className="mr-1" />
                  Batch Refund
                </Typography>
              </div>
            </div>
            <div className="row pl-3 pt-4 pr-3 justify-content-between align-items-center">
              <Typography
                style={{
                  fontSize: "18px",
                  fontWeight: 500,
                  fontFamily: "Poppins",
                  color: "rgba(1, 1, 2, 0.6)",
                }}
              >
                Showing 5 results
              </Typography>
              <Button
                onClick={() => handleUploadBatchModal()}
                variant="contained"
                style={{
                  backgroundColor: "rgba(64, 62, 159, 1)",
                  textTransform: "none",
                  width: "158px",
                  height: "42px",
                  fontWeight: 600,
                  fontSize: "14px",
                  borderRadius: "8px",
                  fontFamily: "Poppins",
                }}
              >
                Upload Batch
              </Button>
            </div>

            <UploadBatchModal
              openModal={uploadBatchModal}
              onClose={handleCloseUploadBatchModal}
            />
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            {refundData.length > 0 &&
              refundData.map((item, idx) => (
                <div className="card card-danger">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-2">
                        <div className="form-group">
                          <p className="card-inner-headers">Date created</p>
                          <label className="label-text">{item.date}</label>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <p className="card-inner-headers">No. of items</p>
                          <label className="label-text">{item.noOfItems}</label>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <p className="card-inner-headers">Total Amount</p>
                          <label className="label-text">
                            {item.totalAmount}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <p className="card-inner-headers">
                            Total Refund Amount
                          </p>
                          <label className="label-text">
                            ${item.refundAmount}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <p className="card-inner-headers">Status</p>
                          <label className="label-text">
                            <TbCircleFilled
                              style={{
                                height: "12px",
                                width: "12px",
                                marginRight: "5px",
                                color:
                                  item.status === "In progress"
                                    ? "#DE970D"
                                    : "#188D63",
                              }}
                            />
                            {item.status}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label className="label-text">
                            <Button
                              style={{
                                border: "1px solid rgba(64, 62, 159, 1)",
                                background: "white",
                                width: "160px",
                                color: "rgba(64, 62, 159, 1)",
                                borderRadius: "8px",
                                fontFamily: "Poppins",
                              }}
                              onClick={() => {
                                if (item.action === "Approve") {
                                  handleSubmitActionButton();
                                }
                              }}
                              startIcon={
                                item.action === "Approved" ? (
                                  <BsFillCheckCircleFill
                                    style={{
                                      background: "rgba(213, 251, 210, 1)",
                                      color: "rgba(11, 106, 72, 1)",
                                      width: "16okpx",
                                      height: "16okpx",
                                      color: "#188D63",
                                      visibility: "visible",
                                    }}
                                  />
                                ) : null
                              }
                            >
                              {item.action}
                            </Button>
                            <IoChevronForwardSharp
                              style={{ marginLeft: "8px" }}
                              onClick={() => handleClickForwardIcon()}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <BatchRefundModal
            openModal={batchRefundActionModal}
            onClose={handleCloseBatchRefundActionModal}
          />
        </section>
      </div>
    </>
  );
}
